import { useT } from "@transifex/react";

interface CharacterCountProps {
    currentLength: number;
    maxLength: number;
    dataTestId?: string;
}

/** "12 / 100 characters" hint, shown under a length-capped input while it is being edited. */
const CharacterCount = (props: CharacterCountProps) => {
    const t = useT();

    const t_characterCount = t("{count} / {maxLength} characters", {
        _tags: "SchoolClasses, CreateVocabTraining, CharacterCount",
        count: props.currentLength,
        maxLength: props.maxLength,
    });

    return (
        <span
            data-testid={props.dataTestId}
            className="text-s text-p6-grey-mid text-right"
        >
            {t_characterCount}
        </span>
    );
};

export default CharacterCount;
